<script>
  import Slick from 'vue-slick';
  import 'slick-carousel/slick/slick.css';
  import ProductItem from "@components/List/ProductItem";

  export default {
    components: {
      Slick,
      ProductItem
    },
    props: {
      list: {
        type: Array,
        default: () => {
          return []
        }
      },
      pagination: {
        type: Object,
        default: () => {
          return {}
        }
      },
      type: {
        type: String,
        default: 'carousel',
        validator(value) {
          return [
            'carousel',
            'grid',
          ].includes(value)
        },
      },
    },
    data() {
      const DEFAULT_PAGE_COUNT = 1;

      return {
        pageCount: DEFAULT_PAGE_COUNT,
        slickOptions: {
          slidesToShow: 2,
          slidesToScroll: 1,
          infinite: true,
          initialSlide: DEFAULT_PAGE_COUNT - 1,
          arrows: true,
          centerPadding: '1rem',
          touchThreshold: 3,
          centerMode: true,
          dots: true,
          responsive: [
            {
              breakpoint: 1501,
              settings: {
                arrows: false,
              }
            },
            {
              breakpoint: 992,
              settings: {
                slidesToShow: 1,
                arrows: false,
              }
            }
          ]
        },
      }
    },
    methods: {
      onSlideTo(index) {
        this.$refs.slick.goTo(index - 1)
      },
      onNext() {
        this.$refs.slick.next()
      },
      onPrev() {
        this.$refs.slick.prev()
      },
      onBeforeChange(event, slick, currentSlide, nextSlide) {
        this.pageCount = nextSlide + 1;
      },
      onChangePagination(page) {
        this.$emit('change-page', page)
      }
    }
  }
</script>
<template>
  <div :class="$style.listProduct">
    <template v-if="type === 'carousel'">
      <div class="listProduct__carouselBox" :class="{ 'mb-0': list.length < 2 }">
        <template v-if="list.length < 2">
          <div class="row justify-content-center">
            <div
              v-for="(item, index) in list"
              :key="`carouseItem-${index}`"
              class="listProduct__carouselList__item col-md-6 col-12"
            >
              <ProductItem
                :data="item"
              />
            </div>
          </div>
        </template>
        <template v-else>
          <Slick
            ref="slick"
            :options="slickOptions"
            class="listProduct__carouselList slick isStyleBase isStyleProduct"
            @beforeChange="onBeforeChange"
          >
            <div
              v-for="(item, index) in list"
              :key="`carouseItem-${index}`"
              class="listProduct__carouselList__item"
            >
              <!-- <ProductItem
                :data="item"
                :link-type="linkType"
              /> -->
              <ProductItem
                :data="item"
              />
            </div>
          </Slick>
        </template>
        <!--<div v-if="list.length > 3" :class="$style.navigation">
          <button
            class="navigation__btn navigation__prev"
            @click="onPrev"
          >
            <i class="navigation__icon fal fa-chevron-left"></i>
          </button>
          <button
            class="navigation__btn navigation__next"
            @click="onNext"
          >
            <i class="navigation__icon fal fa-chevron-right"></i>
          </button>
        </div>-->
      </div>
    </template>
    <template v-if="type === 'grid'">
      <div class="listProduct__gridBox">
        <div class="listProduct__gridList row">
          <div
            v-for="(item, index) in list"
            :key="`gridItem-${index}`"
            class="col-md-6 col-12 listProduct__gridList__item"
          >
            <ProductItem
              :data="item"
            />
          </div>
        </div>
        <BasePagination2
          :pagination="pagination"
          @change="onChangePagination"
        />
      </div>
    </template>
  </div>

</template>
<style lang="scss" module>
  .listProduct {
    margin-bottom: 2.5rem;

    :global {
      .listProduct {
        &__carouselBox {
          position: relative;
          margin-right: -2rem;
          margin-bottom: -6rem;
          margin-left: -2rem;
          // margin: 0 auto -6em auto;

          @include max-xl {
            margin-right: 0;
            margin-left: 0;
          }
        }

        &__carouselList {
          width: 100%;
          max-width: 992px;
          margin: 0 auto;

          &__item {

          }
        }

        &__gridBox {

        }

        &__gridList {
          margin-bottom: #{4.25rem - 2.25rem};

          @include max-md {
            margin-right: -0.5rem;
            margin-left: -0.5rem;
          }

          &__item {
            margin-bottom: 2.25rem;

            @include max-md {
              padding-right: 0.5rem;
              padding-left: 0.5rem;
            }
          }
        }
      }

      .slick {
        &.isStyleBase {
        
          .slick-slide {

          }

          .slick-arrow {
            height: calc(100% - 192px);
            margin-top: -96px;
          }

          .slick-prev {
            margin-left: -10rem;
          }

          .slick-next {
            margin-right: -10rem;
          }
        }
        &.isStyleProduct {
          &.slick-dotted {
            @include max-md {
              padding-bottom: 1rem;
            }
          }
          .slick-dots {
            @include max-md {
              bottom: 4.5rem;
            }
          }
        }
      }
    }
  }

</style>
